window.ATRAPI = new (function () {
    var self = this;
    var _protected = BaseAPI.call(self);
    _protected.setApiUrl(publicConfiguration['ATRServers']);

    self.getJobATR = function (brandId, jobId, filterBy) {
        var deferred = $q.defer();
        var filterByString="";
        if (filterBy) {
            filterByString = "?filter_by="+filterBy.join("&filter_by=");
        }
        _protected.request('brands/' + brandId + '/jobs/' + jobId + '/atrs'+filterByString, 'GET').then(function (result) {
            if (result.data && result.status == 200 && result.data.data) {
                deferred.resolve(result.data.data);
            } else {
                deferred.reject(result);
            }
        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };

    self.getPositionATR = function (brandId, position_code, filterBy) {
        var deferred = $q.defer();
        var filterByString="";
        if (filterBy) {
            filterByString = "?filter_by="+filterBy.join("&filter_by=");
        }
        position_code = encodeURIComponent(position_code);
        _protected.request('brands/' + brandId + '/positions/' + position_code + '/atrs'+filterByString, 'GET').then(function (result) {
            if (result.data && result.status == 200 && result.data.data) {
                deferred.resolve(result.data.data);
            } else {
                deferred.reject(result);
            }
        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };

    self.getOfferATR = function (brandId, offerId) {
            var deferred = $q.defer();
            _protected.request('brands/' + brandId + '/offers/' + offerId + '/atrs', 'GET').then(function (result) {
                if (result.data && result.status == 200 && result.data.data) {
                    deferred.resolve(result.data.data && result.data.data.atr);
                } else {
                    deferred.reject(result);
                }
            }, function (err) {
                deferred.reject(err);
            });

            return deferred.promise;
        };


    self.getATRs = function (brandId, queryObj) {
        var deferred = $q.defer();
        _protected.request('brands/' + brandId + '/atrs', 'GET', queryObj).then(function (result) {
            if (result.data && result.data.data) {
                deferred.resolve(result.data.data);
            } else {
                deferred.reject(result);
            }
        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };

    self.getATRById = function (brandId, atrId) {
        var deferred = $q.defer();
        _protected.request('brands/' + brandId + '/atrs/' + atrId, 'GET').then(function (result) {
            if (result.data && result.status == 200 && result.data.data) {
                deferred.resolve(result.data.data);
            } else {
                deferred.reject(result);
            }
        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };

    self.editATR = function (brandId, atrId, payload) {
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/atrs/' + atrId, 'PUT', payload)
            .then(function (result) {
                if (result.data && result.status == 200 && result.data.data) {
                    deferred.resolve(result.data.data);
                } else {
                    deferred.reject(result);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.createATR = function (brandId, payload) {
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/atrs', 'POST', payload)
            .then(function (result) {
                if (result.data && result.status == 200 && result.data.data) {
                    deferred.resolve(result.data.data);
                } else {
                    deferred.reject(result);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.deleteATR = function (brandId, atrId) {
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/atrs/' + atrId, 'DELETE')
            .then(function (result) {
                if (result.data && result.status == 200 && result.data.data) {
                    deferred.resolve(result.data.data);
                } else {
                    deferred.reject(result);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getATRHiringReasons = function () {
        var deferred = $q.defer();

        _protected.request('reasons', 'GET', {atr_type: 'MB'})
            .then(function (result) {
                if (result.data && result.data.data) {
                    deferred.resolve(result.data.data.reasons);
                } else {
                    deferred.reject(result);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getATRsApprovalFlows = function (brandId) {
        var deferred = $q.defer();
        _protected.request('brands/' + brandId + '/approval_flows', 'GET').then(function (result) {
            if (result.data && result.data.data) {
                deferred.resolve(result.data.data.approval_flows);
            } else {
                deferred.reject(result);
            }
        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };

    self.createATRsApprovalFlows = function (brandId, payload) {
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/approval_flows', 'PUT', payload)
            .then(function (result) {
                if (result.data && result.status == 200 && result.data.data) {
                    deferred.resolve(result.data.data);
                } else {
                    deferred.reject(result);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.updateATRStatus = function (brandId, atrId, payload) {
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/atrs/' + atrId + '/action', 'POST', payload)
            .then(function (result) {
                if (result.data && result.status == 200 && result.data.data) {
                    deferred.resolve(result.data.data);
                } else {
                    deferred.reject(result);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.setATRRejectionReason = function (brandId, atrId, payload) {
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/atrs/' + atrId + '/set_reason', 'POST', payload)
            .then(function (result) {
                if (result.data && result.status == 200 && result.data.data) {
                    deferred.resolve(result.data.data);
                } else {
                    deferred.reject(result);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    var brandSettingsCache = {};

    self.getBrandSettings = function (brandId) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "Can't call ATR settings without brand_id";
        }

        if (brandSettingsCache[brandId]) {
            deferred.resolve(angular.copy(brandSettingsCache[brandId]));
        } else {
            _protected.request('brands/' + brandId + '/settings', 'GET')
                .then(function (result) {
                    if (result.data && result.data.data) {
                        brandSettingsCache[brandId] = result.data.data;
                        deferred.resolve(result.data.data);
                    } else {
                        deferred.reject(result);
                    }
                }, function (err) {
                    deferred.reject(err);
                });
        }

        return deferred.promise;
    };

    self.clearBrandSettings = function (brandId) {
        brandSettingsCache[brandId] = null;
    };

    self.getAtrsOwners = function (brandId) {
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/atrs/owners', 'GET')
            .then(function (result) {
                if (result.data && result.data.data) {
                    deferred.resolve(result.data.data);
                } else {
                    deferred.reject(result);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getAtrsPositions = function (brandId) {
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/atrs/positions', 'GET')
            .then(function (result) {
                if (result.data && result.data.data) {
                    deferred.resolve(result.data.data.positions);
                } else {
                    deferred.reject(result);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getBrandAvailableATR = function (brandId, positionCode) {
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/positions/' + positionCode + "/atrs", 'GET')
            .then(function (result) {
                if (result.data && result.data.data) {
                    deferred.resolve(result.data.data.atrs);
                } else {
                    deferred.reject(result);
                }
            }, function (err) {
                deferred.reject(err);
            });


        return deferred.promise;
    };

    self.getBrandAttachedATR = function (brandId, jobId) {
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/jobs/' + jobId + "/atrs", 'GET')
            .then(function (result) {
                if (result.data && result.data.data) {
                    deferred.resolve(result.data.data.atrs);
                } else {
                    deferred.reject(result);
                }
            }, function (err) {
                deferred.reject(err);
            });


        return deferred.promise;
    };

    self.getBNBAtrs = function (brandId, channelCode, queryObj) {
        var deferred = $q.defer();

        if (queryObj["position_codes"] && queryObj["position_codes"].length > 0) {
            queryObj["position_codes"] = queryObj["position_codes"].toString();
        }

        _protected.request('brands/' + brandId + '/channels/' + channelCode + '/atrs', 'GET', queryObj)
            .then(function (result) {
                if (result.data && result.data.data) {
                    deferred.resolve(result.data.data);
                } else {
                    deferred.reject(result);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getBNBAtrById = function (brandId, channelCode, atrId) {
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/channels/' + channelCode + '/atrs/' + atrId, 'GET')
            .then(function (result) {
                if (result.data && result.data.data) {
                    deferred.resolve(result.data.data);
                } else {
                    deferred.reject(result);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getBNBAtrSettings = function (brandId, channelCode) {
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/channels/' + channelCode + '/settings', 'GET')
            .then(function (result) {
                if (result.data && result.data.data) {
                    deferred.resolve(result.data.data);
                } else {
                    deferred.reject(result);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.setBNBAtrSettings = function (brandId, channelCode, payload) {
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/channels/' + channelCode + '/settings', 'PUT', payload)
            .then(function (result) {
                if (result.data && result.status == 200 && result.data.data) {
                    deferred.resolve(result.data.data);
                } else {
                    deferred.reject(result);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.unlinkBNBAtr = function (brandId, channelCode, atrId) {
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/channels/' + channelCode + '/atrs/' + atrId + '/unlink', 'POST')
            .then(function (result) {
                if (result.data && result.status == 200 && result.data.data) {
                    deferred.resolve(result.data.data);
                } else {
                    deferred.reject(result);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

});

